import styled from '@emotion/styled';
import Colors from '../theme/colors';

export const Text2 = styled.span`
  color: ${Colors.text_1};
  leading-trim: both;
  text-edge: cap;
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  line-height: 133%; /* 34.58px */
  letter-spacing: -0.52px;

  @media print {
    font-size: 20px;
  }

  @media (max-width: 1044px) {
    font-size: 20px;
  }
`;
